import React from 'react'
import css from './style.scss'
import store from 'utils/store'
import NavigationBar from 'components/account_page/story_details/navigation'
import {PopupPage} from 'components/container'
import Sidebar from './sidebar';
import Photo from './media/photo';
import Video from './media/video';
import AdBox from 'components/adBox';
import MiniStories from './miniStories'
import {push} from 'react-router-redux'
import {Redirect} from 'react-router-dom'


class StoryDetails extends React.Component{
  handleCloseDetails=()=>{
    store.dispatch(push(this.props.returnTo))
  }
  render(){
    if(this.props.story){
      return (
          <PopupPage noMargins backTo={this.handleCloseDetails}>
            <NavigationBar baseUrl={this.props.returnTo} selected={this.props.story.id} stories={this.props.stories} storyId={this.props.story.id}>
              <div className={css.storyContainer}>
                <MiniStories selected={this.props.story.id} stories={this.props.stories}/>
                <div className={css.detailsContainer}>
                    {this.props.story.type==="VIDEO" && <Video meta={this.props.story.meta} thumb={this.props.story.thumb} src={this.props.story.url} />}
                    {this.props.story.type==="IMAGE" && <Photo src={this.props.story.thumb} />}
                  <Sidebar {...this.props.story}/>
                </div>
                <AdBox width="100%" height="80px"/>
              </div>
            </NavigationBar>
          </PopupPage>
      )
    }else{
      return (<Redirect to={this.props.returnTo} />)
    }
  }
}


export default StoryDetails;



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/index.js